import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from '@mui/material';


const priceCafe = [
    { category: 'Ужин', price: '290.00'},
    { category: 'Обед', price: '480.00'},
    { category: 'Обед + полдник', price: '620.00'},
    { category: 'Завтрак + обед', price: '720.00' },
    { category: 'Обед + ужин', price: '770.00'},
    { category: 'Завтрак + обед + полдник', price: '860.00'},
    { category: 'Обед + полдник + ужин', price: '910.00'},
    { category: 'Завтрак + обед + ужин', price: '1010.00'},
    { category: 'Завтрак + обед + полдник + ужин ', price: '1150.00'},
];

const CafePrice = () => {
    return (
        <TableContainer component={Paper} sx={{ maxWidth: 860, margin: '20px auto', boxShadow: 3 }}>
            <Typography variant={'h6'} align={'center'}>Стоимость питания</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Категория</TableCell>
                        <TableCell>Стоимость, рублей/день</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {priceCafe.map((entry, idx) => (
                        <TableRow key={entry} hover>
                            <TableCell>{entry.category}</TableCell>
                            <TableCell>{entry.price}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default CafePrice;
